import theme from 'theme';

export const centerModalSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const modalContentSx = {
  padding: theme.padding.content,
  background: theme.palette.background.default,
  overflowY: 'auto',
  maxHeight: '100%'
};

export const modalStackSx = {
  alignItems: 'center'
};

export const dialogContentSx = [modalContentSx, {
  width: {
    xs: '100vw',
    lg: '90vw'
  },
  height: {
    xs: '100vh',
    lg: '90vh'
  }
}];
